export const DATE_FORMAT = "YYYY-MM-DD";

export const STORAGE_KEY = {
  eduSubject: "eduSubject",
  startTime: "startTime",
  endTime: "endTime",
  sourceService: "sourceService",
};
